import { render, staticRenderFns } from "./Flights.vue?vue&type=template&id=073f0206&scoped=true&"
import script from "./Flights.vue?vue&type=script&lang=js&"
export * from "./Flights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073f0206",
  null
  
)

export default component.exports